export const LISTAR_TRONCOS = 'LISTAR_TRONCOS'
export const LISTAR_TRONCO_SELECIONADO = 'LISTAR_TRONCO_SELECIONADO'
export const LISTAR_TRONCO_USE = 'LISTAR_TRONCO_USES'
export const LISTAR_ROTAS = 'LISTAR_ROTAS'
export const LISTAR_GRUPOS_DE_ROTAS = 'LISTAR_GRUPOS_DE_ROTAS'
